import Link from "next/link";
import React from "react";

export default function MobileNavLink({
  href,
  children,
  onClick,
  itemColor,
}: Readonly<{
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
  itemColor?: string;
}>) {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={`block px-5 py-4 hover:bg-gray-50 hover:text-primary transition-colors ${itemColor}`}
    >
      {children}
    </Link>
  );
}